import React, { useCallback, useState } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import SearchResultsView from "../SearchResultsView";
import WizardStepDialog from "./WizardStepDialog";
import ItemIdAssetModal from "src/views/shopping/Orders/ItemIdAssetModal";
import { ProjectProvider } from "src/contexts/project";
import { LOCATION_SNAPSHOT_ADD_ITEM_STEPS, getLocationSnapshotAddItemStepMeta } from "../../steps";

const { SEARCH_RESULTS } = LOCATION_SNAPSHOT_ADD_ITEM_STEPS;

export default function SearchResultsStepDialog({
  open,
  onClose,
  searchResults,
  selectingAssetId,
  onSelectSearchAsset,
  onBack,
}) {
  const { step, steps } = getLocationSnapshotAddItemStepMeta(SEARCH_RESULTS);
  const [selectedAsset, setSelectedAsset] = useState(null);

  const handleSelectAsset = useCallback(
    asset => {
      if (selectingAssetId) {
        return;
      }
      setSelectedAsset(asset || null);
    },
    [selectingAssetId]
  );

  const handleCloseAssetDetails = useCallback(() => {
    if (!selectingAssetId) {
      setSelectedAsset(null);
    }
  }, [selectingAssetId]);

  const handleAddItemToLocation = useCallback(() => {
    if (!selectedAsset?.id || selectingAssetId) {
      return;
    }

    onSelectSearchAsset(selectedAsset);
  }, [onSelectSearchAsset, selectedAsset, selectingAssetId]);

  const isAddingSelectedAsset =
    Boolean(selectedAsset?.id) && selectingAssetId === selectedAsset.id;

  return (
    <>
      <WizardStepDialog
        open={open}
        title="Select Item to Move"
        onClose={onClose}
        step={step}
        steps={steps}
        actions={
          <Button variant="outlined" onClick={onBack} disabled={Boolean(selectingAssetId)}>
            Back
          </Button>
        }
      >
        <SearchResultsView
          assets={searchResults}
          onSelect={handleSelectAsset}
          selectingAssetId={selectingAssetId}
        />
      </WizardStepDialog>
      {selectedAsset?.id && selectedAsset?.project?.id && (
        <ProjectProvider id={selectedAsset.project.id} loadingComponent={<span />}>
          <ItemIdAssetModal
            id={selectedAsset.id}
            onClose={handleCloseAssetDetails}
            narrow
            footerActions={
              <Button
                variant="contained"
                onClick={handleAddItemToLocation}
                fullWidth
                disabled={Boolean(selectingAssetId)}
                startIcon={
                  isAddingSelectedAsset ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : undefined
                }
              >
                Add Item to Location
              </Button>
            }
          />
        </ProjectProvider>
      )}
    </>
  );
}
